import { render } from "./LibrarySearch.vue?vue&type=template&id=cce04e12&lang=pug"
import script from "./LibrarySearch.vue?vue&type=script&lang=js"
export * from "./LibrarySearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__